import { Component, OnInit } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ApprovalType } from '../../entities/enums/approval-type';
import { CookiesNameType } from '../../entities/enums/cookies-name-type';
import { TextUtils } from '../../utils/text.utils';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'gryf-cookies-edit-modal',
  templateUrl: './cookies-edit-modal.component.html',
})
export class CookiesEditModalComponent implements OnInit {

  googleAnalytics: ApprovalType = ApprovalType.DISAGREE;
  googleAds: ApprovalType = ApprovalType.DISAGREE;

  constructor(
    private dialogRef: MatDialogRef<CookiesEditModalComponent>,
    private cookieService: CookieService,
  ) {
  }

  ngOnInit(): void {
    this.setAnswers();
  }

  saveCookies(): void {
    this.cookieService.delete(CookiesNameType.ANALYTICAL_COOKIES);
    this.cookieService.delete(CookiesNameType.PERSONALIZED_ADS);

    if (this.googleAnalytics === ApprovalType.AGREE || this.googleAds === ApprovalType.AGREE) {
      if (this.googleAnalytics === ApprovalType.AGREE) {
        this.cookieService.set(CookiesNameType.ANALYTICAL_COOKIES, TextUtils.randomString(30));
      }
      if (this.googleAds === ApprovalType.AGREE) {
        this.cookieService.set(CookiesNameType.PERSONALIZED_ADS, TextUtils.randomString(30));
      }
    }
    this.close(true);
  }

  private setAnswers(): void {
    this.setGoogleAnalytics();
    this.setGoogleAds();
  }

  private setGoogleAnalytics(): void {
    if (this.cookieService.get(CookiesNameType.ANALYTICAL_COOKIES)) {
      this.googleAnalytics = ApprovalType.AGREE;
    }
  }

  private setGoogleAds(): void {
    if (this.cookieService.get(CookiesNameType.PERSONALIZED_ADS)) {
      this.googleAds = ApprovalType.AGREE;
    }
  }

  get typeOfApprovalType(): typeof ApprovalType {
    return ApprovalType;
  }

  close(value: boolean): void {
    this.dialogRef.close(value);
  }
}
